<style></style>
<template>
    <div class="container invites">
        <div class="form-group">
            <label>New Registration Code:</label>
            <input v-model="new_code.reg_code" type="text" class="form-control"></input>
        </div>
        <div class="form-group">
            <label>Partner:</label>
            <select v-model="new_code.partner_id" class="form-control mb-3">
                <option v-for="option in partner_options" :value="option.value">{{ option.text }}</option>
            </select>
        </div>
        <div class="form-group">
            <label>TA Consultant:</label>
            <select v-model="new_code.consultant_id" class="form-control mb-3">
                <option v-for="option in consultant_options" :value="option.value">{{ option.text }}</option>
            </select>
        </div>
        <div class="form-group">
            <fieldset>
                <legend class="col-form-label pt-0">Status:</legend>
                <template v-for="(option,index) in status_options">
                    <div class="custom-control custom-control-inline custom-radio">
                        <input v-model="new_code.enabled" type="radio" :value="option.value" :id="`statusChoice${index}`" :key="`statusChoice${index}`" class="custom-control-input" name="code_status" aria-label="Radio button for registration code status" />
                        <label :for="`statusChoice${index}`" class="custom-control-label">{{ option.text }}</label>
                    </div>
                </template>
            </fieldset>
        </div>
        <button class="btn btn-orange-blue" @click="createCode" :disabled="selectedPartner.inactive == 1">Submit</button>
        <div v-show="selectedPartner.inactive == 1" class="text-center alert alert-danger my-2">{{ codeErrorText }}</div>
    </div>
</template>
<script>
    import { mapWritableState } from 'pinia';
    import { useRegistrationCodesStore } from './store.js';

    export default {
        props: {
            partners: {
                type: Array,
                required: true
            },
            consultants: {
                type: Array,
                required: true
            },
        },
        data() {
            return {
                new_code: {},
                status_options: [
                    { text: 'Enabled', value: 1 },
                    { text: 'Disabled', value: 0 }
                ]
            }
        },
        computed: {
            partner_options: function () {
                let options = [];
                for (var i = 0; i < this.partners.length; i++) {
                    options.push({'value':this.partners[i].id, 'text': this.partners[i].name})
                }
                return options
            },
            consultant_options: function () {
                let options = [];
                for (var i = 0; i < this.consultants.length; i++) {
                    options.push({'value':this.consultants[i].id, 'text': this.consultants[i].name})
                }
                return options
            },
            selectedPartner: function() {
                return this.partners.find(p => p.id == this.new_code.partner_id) || {};
            },
            codeErrorText: function() {
                return "This partner is inactive and cannot been assigned a registration code.";
            },
            ...mapWritableState(useRegistrationCodesStore, [
                'refreshCodes',
                'showModal'
            ]),
        },
        methods: {
            initCodeObject () {
                this.new_code = {}
                this.new_code.reg_code = this.generateRUCString()
            },
            generateRUCString () { // 8 character random upper case string
                let chars = "ABCDEFGHIJKLMNOPQRSTUVWXTZ"
                let string = ''
                for (let i = 0; i < 8; i++) {
                    let rnum = Math.floor(Math.random() * chars.length)
                    string += chars.substring(rnum, rnum + 1)
                }
                return string
            },
            createCode() {
                axios.post('/api/registration-codes', {
                    code: this.new_code.reg_code,
                    partner_id: this.new_code.partner_id,
                    consultant_id: this.new_code.consultant_id,
                    enabled: this.new_code.enabled
                })
                .then(function (response) {
                    this.refreshCodes = !this.refreshCodes; // toggle to trigger reg code refresh
                    this.showModal = false;
                    this.initCodeObject()
                }.bind(this))
                    .catch(function (error) {
                        console.error(error)
                    })
            },
        },
        mounted() {
            this.initCodeObject();
        }
    }
</script>